import { render, staticRenderFns } from "./ReportProperties.vue?vue&type=template&id=7de177a7&scoped=true&"
import script from "./ReportProperties.vue?vue&type=script&lang=js&"
export * from "./ReportProperties.vue?vue&type=script&lang=js&"
import style0 from "./ReportProperties.vue?vue&type=style&index=0&id=7de177a7&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7de177a7",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pro-tekt/protekt_webapp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7de177a7')) {
      api.createRecord('7de177a7', component.options)
    } else {
      api.reload('7de177a7', component.options)
    }
    module.hot.accept("./ReportProperties.vue?vue&type=template&id=7de177a7&scoped=true&", function () {
      api.rerender('7de177a7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/stats/ReportProperties.vue"
export default component.exports